import GPFilterRow from '@/components/GPFilterRow';
import GPSearchField from '@/components/GPSearchField';
import { FormSectionType } from '@/types/forms';
import { Box, Typography } from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import IconTabs, { ViewsType } from './IconTabs';

type HeaderTabProps = {
  id?: string;
  subTabs?: boolean;
  searchHint?: string;
  currentView: ViewsType;
  tabTitle: string;
  setCurrentView: (view: ViewsType) => void;
  onSubmit?: () => void;
  viewTabs?: ViewsType[];
  showInputSearch?: boolean;
  showFilters?: boolean;
  showSearch?: boolean;
  filters?: FormSectionType[];
  visuallyHideTitle?: boolean;
};

const HeaderTab = ({
  currentView,
  setCurrentView,
  searchHint,
  onSubmit,
  viewTabs = [],
  tabTitle,
  id = `search-${tabTitle}`,
  showInputSearch = true,
  showFilters = true,
  showSearch = true,
  filters,
  visuallyHideTitle = false,
}: HeaderTabProps) => {
  const searchSectionElement = showSearch ? (
    <Box
      role="search"
      aria-label="Search"
      sx={{
        gridColumn: 'span 2',
        mb: 3,
      }}
    >
      <form onSubmit={onSubmit}>
        {showInputSearch && <GPSearchField id={id} name="keyword" hint={searchHint} />}
        {filters && showFilters && (
          <Box>
            <GPFilterRow filterButtons={filters} />
          </Box>
        )}
      </form>
    </Box>
  ) : null;

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: '1fr max-content',
        gap: 1,
        alignItems: 'center',
      }}
    >
      <Typography variant="h4" component="h2" sx={visuallyHideTitle ? visuallyHidden : undefined}>
        {tabTitle}
      </Typography>
      {viewTabs.length > 1 && (
        // pin to the 2nd column so it stays right even when the title is visually hidden (out of grid flow)
        <Box sx={{ gridColumn: 2, justifySelf: 'end' }}>
          <IconTabs tabs={viewTabs} onClick={setCurrentView} currentView={currentView} />
        </Box>
      )}
      {searchSectionElement}
    </Box>
  );
};

export default HeaderTab;
